module.exports = __webpack_public_path__ + "img/20211122.52092877.png";